const isSSR = () => typeof window === "undefined";
export {
  isSSR
};
//# sourceMappingURL=ssr-utils.js.map
